function getAddressToggles() {
  var els = document.querySelectorAll(".address-line");
  return els;
}

function bindAddressToggles() {
  var addresses = getAddressToggles();
  if (addresses.length > 0) {
    for (var i = 0; i < addresses.length; i++) {
      addresses[i].addEventListener("click", function (e) {
        var el = e.target;
        var panel = document.querySelector(".address-panel");
        panel.innerHTML = "";
        var toggle = el.getAttribute("data-toggle");
        if (!getDisplay(panel)) {
          // if we're desktop because panel is hidden for mobile
          var addresses = document.querySelectorAll(".address");
          for (var a = 0; a < addresses.length; a++) {
            addresses[a].classList.remove("show");
          }
        }
        var targetEl = document.querySelector(toggle);
        if (targetEl.classList.contains("show")) {
          targetEl.classList.remove("show");
          panel.innerHTML = "";
        } else {
          targetEl.classList.add("show");
          panel.innerHTML = targetEl.innerHTML;
        }
        return false; // prevent default
      });
    }
  }
}

function getDisplay(element) {
  return element.offsetHeight === 0 && element.offsetWidth === 0;
}

function bindBundleBuilderReadMore() {
  if (document.getElementById("bundle-builder-app--bundle--data") !== null) {
    var jsonText = document.getElementById("bundle-builder-app--bundle--data")
      .innerText;
    var json = JSON.parse(jsonText);
    // var readMores = document.querySelectorAll(".bundle-builder-app--bundle--product--show-more");
    // for(var i=0; i< readMores.length; i++) {
    //   readMores[i].addEventListener("click", function(e){
    //     var el = e.target;
    //     if (el.nodeName === 'SPAN') {
    //       el = el.parentNode;
    //     }
    //     var target = el.getAttribute("href");
    //     console.log("Target = ",target,el);
    //     // now make html request
    //     var oReq = new XMLHttpRequest();
    //     oReq.open("GET", target, true);
    //     oReq.onload = function () { console.log(getHTML(this, "allergy-wrapper")); };
    //     oReq.send(null);
    //   });
    // }
    // console.log("Found json:",json);
    allergenContent = {};

    for (var i = 0; i < json.products.length; i++) {
      if (typeof json.products[i].tags === "object") {
        //console.log("processing product " + i, json.products[i]);
        if (json.products[i].tags.length > 0) {
          // console.log("Product["+i+"]:tags = ",json.products[i].tags );
          for (var j = 0; j < json.products[i].tags.length; j++) {
            var tag = json.products[i].tags[j];
            if (tag.indexOf("allergen-") > -1) {
              // var tmpTag = tag.replace("allergen-","Allergen(s): ");
              // tmpTag = tmpTag.replace(/-/gi," ");
              // json.products[i].tags[j] = tmpTag;
              // json.products[i].description += "<b>" + tmpTag + "</b>";
              // console.log("Description: ",json.products[i].description);
              allergenContent[tag] = loadHtml("/pages/" + tag, tag, function (
                text
              ) {
                allergenContent[tag] = text;
              });
            }
          }
        }
      }
    }
    document.getElementById(
      "bundle-builder-app--bundle--data"
    ).innerText = JSON.stringify(json);

    var links = document.querySelectorAll(
      "a.bundle-builder-app--bundle--product--show-more"
    );
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener("click", function () {
        setTimeout(function () {
          var allergy = document.querySelector(
            ".bundle-builder-app--product-modal--content .bundle-builder-app--bundle--product-description a"
          );
          var title = document.querySelector(
            ".bundle-builder-app--product-modal--content .bundle-builder-app--bundle--product-name"
          );
          var description = document.querySelector(
            ".bundle-builder-app--product-modal--content .bundle-builder-app--bundle--product-description"
          );
          var titleText = title.innerText;
          // console.log("typeof", typeof allergy);
          if (typeof allergy !== "undefined" && allergy !== null) {
            var link = allergy.getAttribute("href");
            // console.log("allergy-link:" + link);
          }
          for (var j = 0; j < json.products.length; j++) {
            if (titleText.indexOf(json.products[j].title) > -1) {
              var newNode = document.createElement("div");
              for (var k = 0; k < json.products[j].tags.length; k++) {
                // var details = document.createElement("DETAILS");
                // details.innerHTML = allergenContent[json.products[j].tags[k]];
                if (json.products[j].tags[k].indexOf("allergen") > -1) {
                  newNode.appendChild(
                    allergenContent[json.products[j].tags[k]]
                  );
                }
              }
              // newNode.innerText = json.products[j].tags.join(",");
              if (typeof allergy !== "undefined" && allergy !== null) {
                allergy.replaceWith(newNode);
              } else {
                description.appendChild(newNode);
              }
            }
          }
        }, 250);
      });
    }

    // var oldShowMore = window.BundleBuilder.showMoreModal;
    // window.BundleBuilder.showMoreModal = function(variantId, sectionIndex, canSelectVariant, canAdd) {
    //   console.log(variantId,sectionIndex,canSelectVariant,canAdd);
    //   oldShowMore(variantId,sectionIndex,canSelectVariant,canAdd);
    // };
  }
}

function getHTML(oXHR, sTargetId) {
  var doc = new DOMParser().parseFromString(oXHR.responseText, "text/html");

  // console.log("trying to find '#"+sTargetId+"' in html");
  var required = doc.querySelector("article");
  var header = required.querySelector("h1");
  var section = required.querySelector("section");
  var details = doc.createElement("details");
  var summary = doc.createElement("summary");
  summary.append(header.innerText);
  details.appendChild(summary);
  details.append(section.innerText);

  return details;
}

function loadHtml(url, targetId, callback) {
  console.log("loading #" + targetId + " from: " + url);
  var oReq = new XMLHttpRequest();
  oReq.open("GET", url, true);
  oReq.withCredentials = true;
  // oReq.setRequestHeader('Access-Control-Request-Method', 'GET');
  oReq.setRequestHeader("X-PINGOTHER", "pingpong");
  oReq.setRequestHeader("Content-Type", "text/plain");
  oReq.setRequestHeader("Accepts", "text/plain");
  // oReq.responseType = 'document';
  oReq.addEventListener("error", handleXHRErrorEvent);
  // oReq.onerror = console.log(this);
  oReq.onload = function () {
    if (oReq.readyState === oReq.DONE) {
      if (oReq.status === 200) {
        // console.log(oReq.response);
        // console.log("Response text:'" + oReq.responseText + "'");
        allergenContent[targetId] = getHTML(oReq, targetId);
      }
    }
  };

  oReq.send();
}

function handleXHRErrorEvent(e) {
  console.log(e.type + ":" + e.loaded);
}

bindAddressToggles();
bindBundleBuilderReadMore();
